// import React, { useState } from "react";

// function ViewTravelRequests({ data }) {
//   const pending = data.filter((req) => req.status === 1 || req.status === 2);
//   const completed = data.filter((req) => req.status === 3);
//   const rejected = data.filter((req) => req.status === 0);

//   const [activeTab, setActiveTab] = useState("Pending");

//   const getStatusText = (status) => {
//     switch (status) {
//       case 0:
//         return "Rejected";
//       case 1:
//         return "Pending (Admin)";
//       case 2:
//         return "Pending (Finance)";
//       case 3:
//         return "Completed";
//       default:
//         return "Unknown";
//     }
//   };

//   const styles = {
//     card:
//       "bg-white border border-gray-200 rounded-lg p-4 shadow hover:shadow-lg transition-all",
//     field: "text-xs text-gray-700 mb-1",
//     label: "font-semibold text-gray-600",
//   };

//   const CARDS_PER_PAGE = 8;

//   // Pagination hook
//   const usePagination = (items) => {
//     const [currentPage, setCurrentPage] = useState(1);
//     const totalPages = Math.ceil(items.length / CARDS_PER_PAGE);

//     const currentItems = items.slice(
//       (currentPage - 1) * CARDS_PER_PAGE,
//       currentPage * CARDS_PER_PAGE
//     );

//     const goToPage = (page) => {
//       if (page < 1 || page > totalPages) return;
//       setCurrentPage(page);
//     };

//     return { currentPage, totalPages, currentItems, goToPage };
//   };

//   const pendingPagination = usePagination(pending);
//   const completedPagination = usePagination(completed);
//   const rejectedPagination = usePagination(rejected);

//   const PaginationControls = ({ currentPage, totalPages, onPageChange }) => (
//     <div className="flex justify-center items-center mt-4 space-x-3">
//       <button
//         onClick={() => onPageChange(currentPage - 1)}
//         disabled={currentPage === 1}
//         className={`px-3 py-1 rounded border ${
//           currentPage === 1
//             ? "border-gray-300 text-gray-400 cursor-not-allowed"
//             : "border-gray-500 text-gray-700 hover:bg-gray-200"
//         }`}
//       >
//         Prev
//       </button>

//       <span className="text-sm text-gray-600">
//         Page {currentPage} of {totalPages}
//       </span>

//       <button
//         onClick={() => onPageChange(currentPage + 1)}
//         disabled={currentPage === totalPages}
//         className={`px-3 py-1 rounded border ${
//           currentPage === totalPages || totalPages === 0
//             ? "border-gray-300 text-gray-400 cursor-not-allowed"
//             : "border-gray-500 text-gray-700 hover:bg-gray-200"
//         }`}
//       >
//         Next
//       </button>
//     </div>
//   );

//   const CardSection = ({ title, color, requests, pagination }) => (
//     <section className="bg-white border rounded-lg shadow-sm p-6 mb-10">
//       <h2
//         className={`text-xl font-semibold mb-5 ${color} border-b pb-2`}
//         aria-label={title}
//       >
//         {title}
//       </h2>
//       {requests.length === 0 ? (
//         <p className="text-gray-400 italic text-center py-8">
//           No {title.toLowerCase()}.
//         </p>
//       ) : (
//         <>
//           <div className="grid gap-4 grid-cols-4">
//             {pagination.currentItems.map((req) => (
//               <div key={req.request_id} className={styles.card}>
//                 <h3 className="text-md font-semibold text-purple-700 mb-3 truncate">
//                   Request #{req.request_id}
//                 </h3>
//                 <p className={styles.field}>
//                   <span className={styles.label}>Project:</span> {req.project_name}
//                 </p>
//                 <p className={styles.field}>
//                   <span className={styles.label}>From:</span> {req.source} →{" "}
//                   <span className={styles.label}>To:</span> {req.destination}
//                 </p>
//                 <p className={styles.field}>
//                   <span className={styles.label}>Date:</span>{" "}
//                   {new Date(req.date).toLocaleDateString()}
//                 </p>
//                 <p className={styles.field}>
//                   <span className={styles.label}>Status:</span>{" "}
//                   {getStatusText(req.status)}
//                 </p>
//                 <p className={styles.field}>
//                   <span className={styles.label}>Price:</span>{" "}
//                   {req.price ? `${req.price}` : "Not set"}
//                 </p>
//               </div>
//             ))}
//           </div>

//           {pagination.totalPages > 1 && (
//             <PaginationControls
//               currentPage={pagination.currentPage}
//               totalPages={pagination.totalPages}
//               onPageChange={pagination.goToPage}
//             />
//           )}
//         </>
//       )}
//     </section>
//   );

//   return (
//     <div className="p-8 bg-gray-50 min-h-screen">
//       {/* Top Summary Tabs */}
//       <div className="flex justify-around mb-8">
//         <button
//           onClick={() => setActiveTab("Pending")}
//           className={`flex-1 mx-2 py-3 rounded shadow text-sm font-semibold transition ${
//             activeTab === "Pending"
//               ? "bg-yellow-500 text-white"
//               : "bg-yellow-100 text-yellow-700 hover:bg-yellow-200"
//           }`}
//         >
//           Pending ({pending.length})
//         </button>
//         <button
//           onClick={() => setActiveTab("Completed")}
//           className={`flex-1 mx-2 py-3 rounded shadow text-sm font-semibold transition ${
//             activeTab === "Completed"
//               ? "bg-green-500 text-white"
//               : "bg-green-100 text-green-700 hover:bg-green-200"
//           }`}
//         >
//           Approved ({completed.length})
//         </button>
//         <button
//           onClick={() => setActiveTab("Rejected")}
//           className={`flex-1 mx-2 py-3 rounded shadow text-sm font-semibold transition ${
//             activeTab === "Rejected"
//               ? "bg-red-500 text-white"
//               : "bg-red-100 text-red-700 hover:bg-red-200"
//           }`}
//         >
//           Rejected ({rejected.length})
//         </button>
//       </div>

//       {/* Conditional Card Section */}
//       {activeTab === "Pending" && (
//         <CardSection
//           title="Pending Requests"
//           color="text-yellow-600"
//           requests={pending}
//           pagination={pendingPagination}
//         />
//       )}
//       {activeTab === "Completed" && (
//         <CardSection
//           title="Approved Requests"
//           color="text-green-600"
//           requests={completed}
//           pagination={completedPagination}
//         />
//       )}
//       {activeTab === "Rejected" && (
//         <CardSection
//           title="Rejected Requests"
//           color="text-red-600"
//           requests={rejected}
//           pagination={rejectedPagination}
//         />
//       )}
//     </div>
//   );
// }

// export default ViewTravelRequests;










import React, { useState } from "react";

function ViewTravelRequests({ data }) {
  const pending = data.filter((req) => req.status === 1 || req.status === 2);
  const completed = data.filter((req) => req.status === 3);
  const rejected = data.filter((req) => req.status === 0);

  const [activeTab, setActiveTab] = useState("Pending");

  const getStatusText = (status) => {
    switch (status) {
      case 0:
        return "Rejected";
      case 1:
        return "Pending (Admin)";
      case 2:
        return "Pending (Finance)";
      case 3:
        return "Completed";
      default:
        return "Unknown";
    }
  };

  const styles = {
    card:
      "bg-white border border-gray-200 rounded-lg p-4 sm:p-5 lg:p-6 shadow hover:shadow-lg transition-all",
    field: "text-xs text-gray-700 mb-1",
    label: "font-semibold text-gray-600",
  };

  const CARDS_PER_PAGE = 8;

  // Pagination hook
  const usePagination = (items) => {
    const [currentPage, setCurrentPage] = useState(1);
    const totalPages = Math.ceil(items.length / CARDS_PER_PAGE);

    const currentItems = items.slice(
      (currentPage - 1) * CARDS_PER_PAGE,
      currentPage * CARDS_PER_PAGE
    );

    const goToPage = (page) => {
      if (page < 1 || page > totalPages) return;
      setCurrentPage(page);
    };

    return { currentPage, totalPages, currentItems, goToPage };
  };

  const pendingPagination = usePagination(pending);
  const completedPagination = usePagination(completed);
  const rejectedPagination = usePagination(rejected);

  const PaginationControls = ({ currentPage, totalPages, onPageChange }) => (
    <div className="flex justify-center items-center mt-4 space-x-3">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className={`px-3 py-1 rounded border ${
          currentPage === 1
            ? "border-gray-300 text-gray-400 cursor-not-allowed"
            : "border-gray-500 text-gray-700 hover:bg-gray-200"
        }`}
      >
        Prev
      </button>

      <span className="text-sm text-gray-600">
        Page {currentPage} of {totalPages}
      </span>

      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className={`px-3 py-1 rounded border ${
          currentPage === totalPages || totalPages === 0
            ? "border-gray-300 text-gray-400 cursor-not-allowed"
            : "border-gray-500 text-gray-700 hover:bg-gray-200"
        }`}
      >
        Next
      </button>
    </div>
  );

  const CardSection = ({ title, color, requests, pagination }) => (
    <section className="bg-white border rounded-lg shadow-sm p-6 mb-10">
      <h2
        className={`text-xl font-semibold mb-5 ${color} border-b pb-2`}
        aria-label={title}
      >
        {title}
      </h2>
      {requests.length === 0 ? (
        <p className="text-gray-400 italic text-center py-8">
          No {title.toLowerCase()}.
        </p>
      ) : (
        <>
          <div className="max-h-[60vh] overflow-y-auto pr-2">
            <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
              {pagination.currentItems.map((req) => (
                <div key={req.request_id} className={styles.card}>
                  <h3 className="text-md font-semibold text-purple-700 mb-3 truncate">
                    Request #{req.request_id}
                  </h3>
                  <p className={styles.field}>
                    <span className={styles.label}>Project:</span> {req.project_name}
                  </p>
                  <p className={styles.field}>
                    <span className={styles.label}>From:</span> {req.source} →{" "}
                    <span className={styles.label}>To:</span> {req.destination}
                  </p>
                  <p className={styles.field}>
                    <span className={styles.label}>Date:</span>{" "}
                    {new Date(req.date).toLocaleDateString()}
                  </p>
                  <p className={styles.field}>
                    <span className={styles.label}>Status:</span>{" "}
                    {getStatusText(req.status)}
                  </p>
                  <p className={styles.field}>
                    <span className={styles.label}>Price:</span>{" "}
                    {req.price ? `${req.price}` : "Not set"}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {pagination.totalPages > 1 && (
            <PaginationControls
              currentPage={pagination.currentPage}
              totalPages={pagination.totalPages}
              onPageChange={pagination.goToPage}
            />
          )}
        </>
      )}
    </section>
  );

  return (
    <div className="bg-gray-50 min-h-screen">
      {/* Outer wrapper: Full viewport height and scroll on small devices, auto height on larger */}
      <div className="px-4 py-6 sm:px-6 lg:px-8 h-screen sm:h-auto overflow-y-auto sm:overflow-visible">
        {/* Top Summary Tabs */}
        <div className="flex flex-col sm:flex-row sm:justify-around gap-3 mb-8">
          <button
            onClick={() => setActiveTab("Pending")}
            className={`w-full sm:flex-1 sm:mx-2 py-3 rounded shadow text-sm font-semibold transition ${
              activeTab === "Pending"
                ? "bg-yellow-500 text-white"
                : "bg-yellow-100 text-yellow-700 hover:bg-yellow-200"
            }`}
          >
            Pending ({pending.length})
          </button>
          <button
            onClick={() => setActiveTab("Completed")}
            className={`w-full sm:flex-1 sm:mx-2 py-3 rounded shadow text-sm font-semibold transition ${
              activeTab === "Completed"
                ? "bg-green-500 text-white"
                : "bg-green-100 text-green-700 hover:bg-green-200"
            }`}
          >
            Approved ({completed.length})
          </button>
          <button
            onClick={() => setActiveTab("Rejected")}
            className={`w-full sm:flex-1 sm:mx-2 py-3 rounded shadow text-sm font-semibold transition ${
              activeTab === "Rejected"
                ? "bg-red-500 text-white"
                : "bg-red-100 text-red-700 hover:bg-red-200"
            }`}
          >
            Rejected ({rejected.length})
          </button>
        </div>

        {/* Conditional Card Section */}
        {activeTab === "Pending" && (
          <CardSection
            title="Pending Requests"
            color="text-yellow-600"
            requests={pending}
            pagination={pendingPagination}
          />
        )}
        {activeTab === "Completed" && (
          <CardSection
            title="Approved Requests"
            color="text-green-600"
            requests={completed}
            pagination={completedPagination}
          />
        )}
        {activeTab === "Rejected" && (
          <CardSection
            title="Rejected Requests"
            color="text-red-600"
            requests={rejected}
            pagination={rejectedPagination}
          />
        )}
      </div>
    </div>
  );
}

export default ViewTravelRequests;


